<template>
  <section class="px-4 max-w-screen-xl mx-auto pb-10 pt-10">
    <h1 class="text-3xl font-bold font-heading mb-8">
      {{ guest.first_name }}, Your Order Is Confirmed!
    </h1>
    <div class="flex flex-col lg:flex-row lg:space-x-20">
      <div class="w-full lg:w-2/5">
        <div class="flex space-x-4 mb-6">
          <img
            :src="currentShow.image"
            :alt="currentShow.name"
            class="rounded-md w-20 h-20 object-cover border border-linear-strong"
          />
          <div>
            <h2 class="font-heading font-semibold text-lg">{{ currentShow.name }}</h2>
            <span class="font-sans" id="formattedDateTime">
              <span id="performanceDate" class="font-sans inline">{{ performanceDate }}</span>
              <span id="showtime" class="block">{{ showtime }}</span>
            </span>
          </div>
        </div>

        <div id="numberOfGuests">{{ numberOfGuests }} Guests</div>
        <div id="seatingTimeDisplay" class="mb-4">{{ seatingTime }} Seating Time</div>

        <CheckoutDetailTable />

        <div class="font-sans my-8">
          We received your order and sent an email confirmation to {{ guest.email }}.
        </div>
        <div>Thank you!</div>
        <div>{{ venueName }}</div>
      </div>

      <div class="w-full lg:w-3/5 mt-12 flex justify-end">
        <img
          :src="`/api/reservation/${backendReservation.id}/png/?width=500`"
          class="w-4/5 object-contain h-full"
        />
      </div>
    </div>
    <div class="mt-8 text-button-guest-primary">
      <router-link :to="{ name: 'setShow' }"> Return to shows. </router-link>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState, mapStores } from 'pinia'
import { defineComponent } from 'vue'

import CheckoutDetailTable from '@/components/CheckoutDetailTable.vue'
import { StorePerformance, StoreReservation, StoreShow } from '@/models'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'

import { GuestRead } from '@generated/types'

export default defineComponent({
  name: 'OrderDetails',
  components: { CheckoutDetailTable },
  beforeMount() {
    if (!this.checkoutStore.reservation || !this.checkoutStore.performance) {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapStores(useCheckoutStore, useSettingStore),
    ...mapState(useSettingStore, ['currency']),

    backendReservation(): StoreReservation {
      if (!this.checkoutStore.reservation) {
        throw new Error('No valid reservation is present')
      }
      return this.checkoutStore.reservation
    },

    guest(): GuestRead {
      if (!this.backendReservation.contact) {
        throw new Error('No valid guest is present')
      }
      return this.backendReservation.contact
    },

    performance(): StorePerformance {
      if (!this.checkoutStore.performance) {
        throw new Error('No valid performance is present')
      }
      return this.checkoutStore.performance
    },

    currentShow(): StoreShow {
      return this.performance.show
    },

    numberOfGuests(): number {
      return this.backendReservation.number_of_guests
    },

    seatingTime(): string {
      return this.checkoutStore.seating_time?.time || ''
    },

    performanceDate(): string {
      return `${this.settingStore.dateLongStr(this.performance.date)}`
    },
    showtime(): string {
      return `${this.settingStore.timeStr(this.performance.datetime)} Showtime`
    },

    venueName(): string {
      return this.settingStore.venue_name
    },
  },
})
</script>
